import React from 'react';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="container-contact">
      <main className="row-contact">
        <section className="col left">
          <div className="contactTitle">
            <h2>Get In Touch</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum consectetur voluptate ab recusandae maxime nesciunt in maiores error porro rem nam, necessitatibus tempore facilis reiciendis.</p>
          </div>
          <div className="contactInfo">
            <div className="iconGroup">
              <div className="icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div className="details">
                <span>Phone</span>
                <span>+91 9895898502</span>
              </div>
            </div>
            <div className="iconGroup">
              <div className="icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="details">
                <span>Email</span>
                <span>betterplacement@gmail.com</span>
              </div>
            </div>
            <div className="iconGroup">
              <div className="icon">
                <FontAwesomeIcon icon={faLocationDot} />
              </div>
              <div className="details">
                <span>Location</span>
                <span>NAZ MALL, KARAKKUNNU JN
                MANJERI</span>
              </div>
            </div>
          </div>
          <div className="socialMedia">
            <Link to={"#"}><FontAwesomeIcon icon={faFacebookF} /></Link>
            <Link to={"#"}><FontAwesomeIcon icon={faTwitter} /></Link>
            <Link to={"#"}><FontAwesomeIcon icon={faInstagram} /></Link>
            <Link to={"#"}><FontAwesomeIcon icon={faLinkedinIn} /></Link>
          </div>
        </section>
        <section className="col right">
          <form action="#" className="messageForm">
            <div className="inputGroup halfWidth">
              <input type="text" required />
              <label>First Name</label>
            </div>
            <div className="inputGroup halfWidth">
              <input type="text" required />
              <label>Last Name</label>
            </div>
            <div className="inputGroup fullWidth">
              <input type="text" required />
              <label>Email</label>
            </div>
            <div className="inputGroup fullWidth">
              <textarea required />
              <label>Message</label>
            </div>
            <div className="inputGroup fullWidth">
              <button>Send Message</button>
            </div>
          </form>
        </section>
      </main>
    </div>
  );
}

export default Contact;
